import { AbilityBuilder, Ability } from "@casl/ability";
import adminAbility from "./adminAbility";

export default function defineAbilityFor(role = null) {
  const { can, cannot, build } = new AbilityBuilder(Ability);

  adminAbility(can, cannot);

  return build();
}
